import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

/**
 * @deprecated Use CustomCurrencyPipe from libs/shared/utils/pipes instead
 */
@Pipe({
  name: 'rxCurrency',
  standalone: true,  
})
export class CustomCurrencyPipe extends CurrencyPipe implements PipeTransform {

  override transform(value: number | string, currencyCode?: string, display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean, digitsInfo?: string, locale?: string): string | null;
  override transform(value: null | undefined, currencyCode?: string, display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean, digitsInfo?: string, locale?: string): null;
  override transform(value: number | string | null | undefined, currencyCode?: string, display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean, digitsInfo?: string, locale?: string): string | null {

    return super.transform(
      value,
      currencyCode,
      currencyCode === 'USD' ? 'symbol-narrow' : currencyCode === 'CAD' ? 'CAD$' : display,
      digitsInfo,
      locale
    );
  }
}
